import PosthogService from '~/services/posthog/PosthogService';
import type { TInviteSentSource } from './types';

export interface IInviteSentPayload {
  source: TInviteSentSource;
  totalInvitesSent: number;
  shiftId?: string;
  professionalId?: string;
  favoriteInvitesSent?: number;
  workedWithInvitesSent?: number;
  newToYouInvitesSent?: number;
}

/**
 * Fires when the user sends invites
 * Event: dental_portal:invite:invite_sent
 */
export function fireInviteSent(payload: IInviteSentPayload): void {
  const properties: Record<string, unknown> = {
    source: payload.source,
    total_invites_sent: payload.totalInvitesSent,
  };

  if (payload.shiftId !== undefined) {
    properties.shift_id = payload.shiftId;
  }
  if (payload.professionalId !== undefined) {
    properties.professional_id = payload.professionalId;
  }
  if (payload.favoriteInvitesSent !== undefined) {
    properties.favorite_invites_sent = payload.favoriteInvitesSent;
  }
  if (payload.workedWithInvitesSent !== undefined) {
    properties.worked_with_invites_sent = payload.workedWithInvitesSent;
  }
  if (payload.newToYouInvitesSent !== undefined) {
    properties.new_to_you_invites_sent = payload.newToYouInvitesSent;
  }

  PosthogService.getInstance().track(
    'dental_portal:invite:invite_sent',
    properties,
  );
}
